class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.megaMenuImages();
	}

	setupEventHandlers() {
		// mobile menu button handler
		const btnMobileMenu = document.getElementsByClassName('site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu[0].addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// Add event listeners to multiple selector targets
		const selectorTargets = [
			{
				selector: '.site-header__mobile-menu .has-children a',
				targets: [
					{
						target: 'li',
						className: 'active'
					}
				]
			},
			{
				selector: '.site-header__menu--primary .has-children',
				targets: [
					{
						target: 'li',
						className: 'active'
					},
					{
						target: 'html',
						className: 'mega-menu-open'
					}
				]
			}
		];

		selectorTargets.forEach(({ selector, targets }) => {
			const menuLinks = document.querySelectorAll(selector);

			menuLinks.forEach((link) => {
				link.addEventListener('click', () => {
					targets.forEach((targetInfo) => {
						if (targetInfo.target === 'li') {
							const listItem = this.findClosestAncestor(link, targetInfo.target);

							if (listItem) {
								if (listItem.classList.contains(targetInfo.className)) {
									listItem.classList.remove(targetInfo.className);
								} else {
									listItem.classList.add(targetInfo.className);
								}
							}
						} else {
							const targetElement = document.querySelector(targetInfo.target);

							if (targetElement) {
								if (targetElement.classList.contains(targetInfo.className)) {
									targetElement.classList.remove(targetInfo.className);
								} else {
									targetElement.classList.add(targetInfo.className);
								}
							}
						}
					});
				});
			});
		});

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());
	}

	megaMenuImages() {
		const menuItems = document.querySelectorAll(
			'.site-header__menu--primary .has-children ul li a'
		);
		const images = document.querySelectorAll(
			'.site-header__menu--primary .has-children .menu-image'
		);

		function activateImage(imageId) {
			images.forEach((image) => {
				if (image.getAttribute('data-image-id') === imageId) {
					image.classList.add('active');
				} else {
					image.classList.remove('active');
				}
			});
		}

		// Automatically activate the image for the first menu item with an image ID
		// So that we at least have an image displaying at page load time, without requiring hover
		const defaultItem = Array.from(menuItems).find((menuItem) =>
			menuItem.getAttribute('data-image-id')
		);
		if (defaultItem) {
			const defaultImageId = defaultItem.getAttribute('data-image-id');
			activateImage(defaultImageId);
		}

		// Add event listeners for other menu items
		menuItems.forEach((menuItem) => {
			menuItem.addEventListener('mouseenter', (event) => {
				const imageId = event.currentTarget.getAttribute('data-image-id');
				activateImage(imageId);
			});
		});
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	findClosestAncestor(element, selector) {
		let currentElement = element;
		while (currentElement !== null && !currentElement.matches(selector)) {
			currentElement = currentElement.parentElement;
		}
		return currentElement;
	}
}

export default SiteHeader;
